/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AdvertisementBanner } from '../models/advertisement-banner';
import { getCountOfMerchants } from '../fn/public-endpoints/get-count-of-merchants';
import { GetCountOfMerchants$Params } from '../fn/public-endpoints/get-count-of-merchants';
import { getCountOfProducts } from '../fn/public-endpoints/get-count-of-products';
import { GetCountOfProducts$Params } from '../fn/public-endpoints/get-count-of-products';
import { getMerchantsLogoUrls } from '../fn/public-endpoints/get-merchants-logo-urls';
import { GetMerchantsLogoUrls$Params } from '../fn/public-endpoints/get-merchants-logo-urls';
import { getPackagingUnitAdvertisementBanners } from '../fn/public-endpoints/get-packaging-unit-advertisement-banners';
import { GetPackagingUnitAdvertisementBanners$Params } from '../fn/public-endpoints/get-packaging-unit-advertisement-banners';
import { MerchantCountResponse } from '../models/merchant-count-response';


/**
 * Public endpoint which can reach without authorization
 */
@Injectable({ providedIn: 'root' })
export class PublicEndpointsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getCountOfProducts()` */
  static readonly GetCountOfProductsPath = '/public/products_count';

  /**
   * Count products.
   *
   * Finds and returns the count of products
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCountOfProducts()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCountOfProducts$Response(params?: GetCountOfProducts$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
    const obs = getCountOfProducts(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Count products.
   *
   * Finds and returns the count of products
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCountOfProducts$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCountOfProducts(params?: GetCountOfProducts$Params, context?: HttpContext): Observable<number> {
    const resp = this.getCountOfProducts$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<number>): number => r.body)
    );
  }

  /** Path part for operation `getPackagingUnitAdvertisementBanners()` */
  static readonly GetPackagingUnitAdvertisementBannersPath = '/public/packaging_unit_advertisement_banner_logos';

  /**
   * Gets packaging unit advertisement banners from packaging-unit-advertisement-banners folder.
   *
   * Finds and returns the url and the id and label of the packaging unit.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPackagingUnitAdvertisementBanners()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPackagingUnitAdvertisementBanners$Response(params?: GetPackagingUnitAdvertisementBanners$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AdvertisementBanner>>> {
    const obs = getPackagingUnitAdvertisementBanners(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets packaging unit advertisement banners from packaging-unit-advertisement-banners folder.
   *
   * Finds and returns the url and the id and label of the packaging unit.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPackagingUnitAdvertisementBanners$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPackagingUnitAdvertisementBanners(params?: GetPackagingUnitAdvertisementBanners$Params, context?: HttpContext): Observable<Array<AdvertisementBanner>> {
    const resp = this.getPackagingUnitAdvertisementBanners$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<AdvertisementBanner>>): Array<AdvertisementBanner> => r.body)
    );
  }

  /** Path part for operation `getCountOfMerchants()` */
  static readonly GetCountOfMerchantsPath = '/public/merchants_count';

  /**
   * Count merchants.
   *
   * Finds and returns the count of the registrated merchants
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCountOfMerchants()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCountOfMerchants$Response(params?: GetCountOfMerchants$Params, context?: HttpContext): Observable<StrictHttpResponse<MerchantCountResponse>> {
    const obs = getCountOfMerchants(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Count merchants.
   *
   * Finds and returns the count of the registrated merchants
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCountOfMerchants$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCountOfMerchants(params?: GetCountOfMerchants$Params, context?: HttpContext): Observable<MerchantCountResponse> {
    const resp = this.getCountOfMerchants$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<MerchantCountResponse>): MerchantCountResponse => r.body)
    );
  }

  /** Path part for operation `getMerchantsLogoUrls()` */
  static readonly GetMerchantsLogoUrlsPath = '/public/banner_logos';

  /**
   * Gets images URL from banner-rotator folder.
   *
   * Finds and returns the valid files from banner-rotator-folder.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMerchantsLogoUrls()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMerchantsLogoUrls$Response(params?: GetMerchantsLogoUrls$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<string>>> {
    const obs = getMerchantsLogoUrls(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets images URL from banner-rotator folder.
   *
   * Finds and returns the valid files from banner-rotator-folder.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMerchantsLogoUrls$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMerchantsLogoUrls(params?: GetMerchantsLogoUrls$Params, context?: HttpContext): Observable<Array<string>> {
    const resp = this.getMerchantsLogoUrls$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<string>>): Array<string> => r.body)
    );
  }

}
